import { render, staticRenderFns } from "./nullData.vue?vue&type=template&id=3f08213a&scoped=true"
import script from "./nullData.vue?vue&type=script&lang=js"
export * from "./nullData.vue?vue&type=script&lang=js"
import style0 from "./nullData.vue?vue&type=style&index=0&id=3f08213a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f08213a",
  null
  
)

export default component.exports